var map = {
	"./APG.png": "9472",
	"./Crane.png": "86b4",
	"./DirectLink.png": "6275",
	"./Spring.png": "c85b",
	"./UBI.png": "bb6f",
	"./Yusen.png": "5471",
	"./Yusen2.png": "e3db",
	"./charter.png": "f354",
	"./eTower.png": "2014",
	"./eTower_normal.png": "c61c",
	"./eTower_reverse_white.png": "9c28",
	"./eTower_white.png": "88ce",
	"./ebay.png": "25ce",
	"./evCargo.png": "c5e9",
	"./postnord.png": "4d9e",
	"./qrl.png": "86e1",
	"./wiseway.png": "e8ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";